import styled from 'styled-components';



export const ResultCard = styled.div`

`

